import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import copy from "clipboard-copy";
import { CustomDialogTitle } from "../../ui";

export const UserInformationDialog = ({ title, user, open, onClose }) => {
  const { name, username, password } = user || {};

  const handleCopyClipboard = async () => {
    onClose();
    await copy(
      `Name : ${name}\nUsername : ${username}\nPassword Sementara : ${password}`
    );
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <CustomDialogTitle variant="h5" title={title} />
      <DialogContent>
        <Typography variant="body2" color="gray">
          Nama
        </Typography>
        <Typography variant="body2" sx={{
          fontWeight: "bold"
        }}>
          {name}
        </Typography>
        <Typography variant="body2" color="gray" sx={{
          mt: 3
        }}>
          Username
        </Typography>
        <Typography variant="body2" sx={{
          fontWeight: "bold"
        }}>
          {username}
        </Typography>
        <Typography variant="body2" color="gray" sx={{
          mt: 3
        }}>
          Password Sementara
        </Typography>
        <Typography variant="body2" sx={{
          fontWeight: "bold"
        }}>
          {password}
        </Typography>
        <Typography variant="subtitle2" color="error" sx={{
          mt: 3
        }}>
          PERHATIAN: INFORMASI TERKAIT PASSWORD SEMENTARA DARI USER TERKAIT{" "}
          <b>HANYA BISA DILIHAT SATU KALI INI SAJA.</b> PASTIKAN ANDA SUDAH
          MENYIMPAN INFORMASI TERSEBUT SEBELUM MENUTUP PESAN INI
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" fullWidth onClick={handleCopyClipboard}>
          Copy ke Clipboard
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserInformationDialog;

UserInformationDialog.propTypes = {
  title: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
